import { Add, Delete as DeleteIcon, DeleteOutline } from '@mui/icons-material';
import {
    Autocomplete,
    Button,
    FormControl,
    Grid, IconButton, InputLabel, MenuItem, Select, TextField,
    Typography
} from '@mui/material';
import { filter, find, lowerCase } from 'lodash';
import { FC } from 'react';

export const isActionsValid = (actions: any[]) => {
    if (!actions.length) return true;
  
    return actions.every(action => {
      if (!action.type || action.type === "") return false;
      if (!action.params) return false;
      return action.params.every((param: any )=> param.value !== undefined && param.value !== null && param.value !== "");
    });
  };

const Action: FC<any> = ({ actionOptions, action, onChangeAction, onDeleteAction }) => {
    const { type, params } = action;

    const handleChangeParamValue = (paramKey: any, value: any) => {
        const updatedParams = [...params];
        const paramIndex = updatedParams.findIndex((param: any) => param?.key === paramKey);
        if (paramIndex > -1) {
            updatedParams[paramIndex] = { ...updatedParams[paramIndex], value };
        }

        onChangeAction({ ...action, params: updatedParams });
    };

    const actionTemplateToData = (actionTemplate: any) => {

        const data: any = { type: actionTemplate?.key, params: {} };
        let params: any = []
        Object.entries(actionTemplate?.params).forEach(([paramKey, paramStructure]: any) => {


            if (paramStructure?.type === "select") {
                params.push({
                    key: paramKey,
                    value: paramStructure?.options[0]?.key
                })
            } else {
                params.push({
                    key: paramKey,
                    value: ""
                })
            }
        }

        );
        data.params = params
        console.log({ data, })
        return data;
    };

    return (
        <Grid container columnSpacing={1} alignItems="center">
            <Grid item xs={3}>
                <FormControl fullWidth>
                    <InputLabel sx={{top: -5}}>Action</InputLabel>
                    <Select
                        size="small"
                        value={type}
                        onChange={(e) => {
                            let actionTemplate = find(actionOptions, { key: e.target.value })
                            let data = actionTemplateToData(actionTemplate)
                            onChangeAction({ ...action, ...data, })
                        }}
                    >
                        {actionOptions?.map((actionOption: any) => {

                            return <MenuItem key={actionOption?.key} value={actionOption?.key}>
                                {actionOption?.label}
                            </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Grid>

            <Grid item xs={7}>
                {params?.map((param: any, index: number) => {

                    const actionTemplate = find(actionOptions, { key: type })
                    const paramStructure = actionTemplate?.params[param?.key]
                    if (paramStructure?.type === "select") {
                        return <FormControl fullWidth>
                            <InputLabel>{param?.key?.charAt(0)?.toUpperCase() + param?.key.slice(1)}</InputLabel>
                            <Select
                                size="small"
                                value={param?.value}
                                onChange={(e) => handleChangeParamValue(param?.key, e.target.value)}
                            >
                                {paramStructure?.options?.map((option: any) => {
                                    return <MenuItem key={option?.key} value={option?.key}>
                                        {option?.label}
                                    </MenuItem>
                                })}
                            </Select>
                        </FormControl>
                    } else if (paramStructure?.type === 'autoComplete') {
                        return <FormControl fullWidth key={param?.key}>
                        <Autocomplete
                          size="small"
                          options={paramStructure?.options || []}
                          getOptionLabel={(option: any) => option?.label || ''}
                          value={
                            paramStructure?.options?.find((opt: any) => opt.key === param?.value) || null
                          }
                          isOptionEqualToValue={(option: any, value: any) => option?.key === value?.key}
                          onChange={(e, value) => handleChangeParamValue(param?.key, value?.key)}
                          filterOptions={(options, state) =>
                            filter(options, (item: any) =>
                              lowerCase(item.label).includes(lowerCase(state.inputValue))
                            )
                          }
                          renderInput={(autocompleteParams) => (
                            <TextField
                              {...autocompleteParams}
                              autoComplete="off"
                              variant="outlined"
                              label={param?.key?.charAt(0)?.toUpperCase() + param?.key.slice(1)}
                            />
                          )}
                        />
                      </FormControl>                   
                      
                    }

                    return <TextField
                        size="small"
                        key={param?.key}
                        fullWidth
                        label={param?.value}
                        value={param?.key}
                        onChange={(e) => handleChangeParamValue(param?.key, e.target.value)}
                    />
                })}
            </Grid>
            <Grid item xs={1}>
                <IconButton onClick={onDeleteAction} color="error">
                    <DeleteOutline />
                </IconButton>
            </Grid>
        </Grid>
    );
};

const ActionsComponent: FC<any> = ({ actions, actionOptions, onChangeActions, onAddAction, onDeleteAction }) => {
    return (
        <Grid container spacing={1} sx={{ mt: 1 }}>
            {actions?.map((action: any, index: number) => (
                <Grid item xs={12} >
                    <Action
                        key={index}
                        actionOptions={actionOptions}
                        action={action}
                        actions={actions}
                        onChangeAction={(newAction: any) => {
                            const updatedActions = [...actions];
                            updatedActions[index] = newAction;
                            onChangeActions(updatedActions);
                        }}
                        onDeleteAction={() => onDeleteAction(index)}
                    />
                </Grid>
            ))}
            <Grid item xs={12}>
                <Button size="small"  onClick={onAddAction} variant='outlined'
                    sx={{borderColor: 'neutral.300', mt:1, width: '110px'}}>
                    <Typography variant='h6' sx={{display: 'flex', alignItems: 'center'}}>Add Action<Add fontSize='small'/></Typography>
                </Button>
            </Grid>
        </Grid>
    );
};

export default ActionsComponent;